﻿import { useEffect, useState } from 'react';
import { EnteredLinks } from '../components/VideoLinks';

export function useDisableSendEmailOnEmptyLinks(enteredLinks: EnteredLinks) {
    let [disableEmailButton, setDisableEmailButton] = useState<boolean>(true);

    useEffect(() => {
        if (Object.values(enteredLinks).some((link) => link.length > 0)) {
            setDisableEmailButton(false);
        } else {
            setDisableEmailButton(true);
        }
    }, [enteredLinks]);

    return disableEmailButton;
}
